import http from '../../../Utils/http';
import httpUploader from '../../../Utils/httpUploader';
const StepsMangment = {
  name: 'StepsMangment',
  state: {
    stepNumber: 0,
    loading: false,
    step1: null,
    step2: null,
    allData: {},
    framesTemplates: null,
    data_exist: false,
  },
  reducers: {
    injectStepData(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    loadFramesTemplates(state, payload) {
      return {
        ...state,
        framesTemplates: payload,
      };
    },
    checkDuplicationReducer(state, payload) {
      return {
        ...state,
        data_exist: payload.exist,
      };
    },
    clearStat(state) {
      return {
        stepNumber: 0,
        loading: false,
        step1: null,
        step2: null,
        allData: {},
        framesTemplates: null,
        data_exist: false,
      };
    },
  },
  effects: (dispatch) => ({
    async storeStepData(data) {
      this.injectStepData(data);
    },

    async fetchFramesTemplates() {
      try {
        this.injectStepData({ loading: true });
        const response = await http.get(`savvy/frame-template/10/1/1`);
        this.loadFramesTemplates(response.data.data.rows);
        this.injectStepData({ loading: false });
      } catch (err) {
        this.injectStepData({ loading: false });
      }
    },
    async checkDuplication(data) {
      try {
        const response = await http.get(
          `savvy/displays/duplication?name=${data.name}&location_name=${data.location_name}&display_location=${data.display_location}`
        );
        this.checkDuplicationReducer(
          response.status === 204 ? { exist: false } : { exist: true }
        );
      } catch (err) {
        console.log(err);
      }
    },

    async postDisplayHandler(data, state) {
      const { step1, step2 } = state.StepsMangment;
      const mediaPlayersSnsArray = step1?.media_palyer_sn;
      const mediaPlayersSns = Array.isArray(mediaPlayersSnsArray) && mediaPlayersSnsArray.length > 0 
        ? mediaPlayersSnsArray.filter(sn => sn && String(sn).trim() !== '').join(', ')
        : null;
      const finalMediaPlayerSn = mediaPlayersSns && mediaPlayersSns.trim() !== '' ? mediaPlayersSns : null;
      const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
      const origin = window.location.origin;
      const userInfo = state.user.data;
      step1.location = {
        lat: step1.latitude,
        lng: step1.longitude,
      };
      delete step1.latitude;
      delete step1.longitude;
      const status = step1.rate_schedule_id ? 'available' : 'unavailable';
      const simplifyAspectRatio = (width, height) => {
        if (!width || !height || width <= 0 || height <= 0) return 'N/A';
        const gcd = (a, b) => b === 0 ? a : gcd(b, a % b);
        const divisor = gcd(width, height);
        const simplifiedW = width / divisor;
        const simplifiedH = height / divisor;
        return `${simplifiedW}:${simplifiedH}`;
      };

      const normalizeRefreshRate = (raw) => {
        const n = Number(raw);
        if ([30, 60, 120, 240].includes(n)) return n;
        return 60;
      };

      const parseAcceptedFileTypes = (screen, fallbackCsv) => {
        if (Array.isArray(screen?.accepted_file_types)) {
          return screen.accepted_file_types;
        }
        return String(screen?.accepted_file_types || fallbackCsv || 'mp4,jpg,png,gif,avi,mov,bmp')
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean);
      };

      const processedScreens = Array.isArray(step2?.screen)
        ? step2.screen.map((screen) => {
          const displayType = screen?.display_type || 'Zoned';
          const refreshRate = normalizeRefreshRate(screen?.refresh_rate);
          const baseScreen = {
            ...screen,
            display_type: displayType,
            orientation: screen?.orientation || 'Landscape',
            size: screen?.size || '55',
            resolution: screen?.resolution || '1920x1080',
            refresh_rate: refreshRate,
          };

          if (displayType === 'LED') {
            const ledWidth = Number(screen?.led_width) || null;
            const ledHeight = Number(screen?.led_height) || null;
            const ledAspectRatio =
              ledWidth && ledHeight ? simplifyAspectRatio(ledWidth, ledHeight) : null;
            const maxFileSize = Number(screen?.max_file_size) || 104857600;
            const acceptedFileTypes = parseAcceptedFileTypes(screen, 'mp4,jpg,png,gif,avi,mov,bmp');

            return {
              ...baseScreen,
              led_width: ledWidth,
              led_height: ledHeight,
              led_aspect_ratio: ledAspectRatio,
              max_file_size: maxFileSize,
              accepted_file_types: acceptedFileTypes,
              metadata: {
                display_type: 'LED',
                led_width: ledWidth,
                led_height: ledHeight,
                led_aspect_ratio: ledAspectRatio,
                max_file_size: maxFileSize,
                accepted_file_types: acceptedFileTypes,
                refresh_rate: refreshRate,
              },
            };
          }

          const acceptedFileTypes = parseAcceptedFileTypes(screen, 'mp4,jpg,png,gif,avi,mov,bmp');

          return {
            ...baseScreen,
            led_width: null,
            led_height: null,
            led_aspect_ratio: null,
            max_file_size: null,
            accepted_file_types: acceptedFileTypes,
          };
        })
        : step2?.screen;

      const allDisplayTypes = new Set();
      if (Array.isArray(processedScreens)) {
        processedScreens.forEach((screen) => {
          const types = Array.isArray(screen?.display_types) && screen.display_types.length > 0
            ? screen.display_types
            : (screen?.display_type ? [screen.display_type] : ['Zoned']);
          
          types.forEach((type) => {
            if (type) {
              const normalized = String(type).trim();
              if (normalized === 'Full Screen') {
                allDisplayTypes.add('FULL_SCREEN');
              } else if (normalized === 'Zoned') {
                allDisplayTypes.add('ZONED');
              } else if (normalized === 'LED') {
                allDisplayTypes.add('LED');
              } else {
                allDisplayTypes.add(normalized.toUpperCase().replace(/\s+/g, '_'));
              }
            }
          });
        });
      }
      
      const displayTypeArray = Array.from(allDisplayTypes);
      if (displayTypeArray.length === 0) {
        displayTypeArray.push('ZONED');
      }

      const toBeCreated = {
        generalInfo: {
          ...step1,
          org_id: userInfo.org_id,
          user_id: userInfo.id,
          visibilityStatus: status,
          media_palyer_sn: finalMediaPlayerSn,
          onBehalf,
          display_type: displayTypeArray,
        },
        screens: processedScreens,
        origin: origin,
      };
      try {
        const response = await http.post('savvy/displays', toBeCreated);
        if (response && response.data) {
          dispatch.ProgressStepDSO.UpdateGetDSOProgressStep(3);
        }
        this.clearStat();
      } catch (err) {
        console.error(err);
      }
    },

    async addFrameToList(data, state) {
      const { step4 } = state.StepsMangment;

      if (
        step4?.find((item) => {
          return item.id === data.id;
        })
      ) {
        const newList = step4?.filter((item) => {
          return item.id !== data.id;
        });
        this.injectStepData({ step4: [...newList, data] });
        return;
      }

      if (!step4) {
        this.injectStepData({ step4: [data] });
      } else {
        this.injectStepData({ step4: [...step4, data] });
      }
    },
    async Upload({ formData }) {
      try {
        this.injectStepData({
          loading: true,
        });
        const response = await httpUploader.post('/utility/upload', formData);
        this.injectStepData({
          loading: false,
        });
        return response.data;
      } catch (err) {
        this.injectStepData({
          loading: false,
        });
        console.error(err);
      }
    },
  }),
};

export default StepsMangment;
